import {BaseSearchDTO} from "../baseSearchDTO.interface";

export interface VehicleFaultCheckSearchDTO extends BaseSearchDTO {
  filters?: {
    vehicleId?: string;
  };
}
